import * as React from "react";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {Module, Node} from "@msdyn365-commerce-modules/utilities";

import {
  ISignInItem,
  ISignInLoading,
  ISignInLocalAccount,
  ISignInSocialAccount,
  ISignInSocialItem,
  ISignInViewProps,
  ISignInB2BAccount,
  ISignInB2BItem,
} from "@msdyn365-commerce-modules/account-management/";

const LocalAccount: React.FC<ISignInLocalAccount> = ({
  localAccount,
  items,
  forgetPassword,
  disclaimer,
  error,
  signInButton,
  //signInB2bAccount,
}) => {
  return (
    <Node {...localAccount}>
      {items &&
        items.map((item: ISignInItem) => {
          return (
            <Node key={item.key} {...item.wrapper}>
              {item.label}
              {item.error}
              {item.input}
            </Node>
          );
        })}
      {forgetPassword}
      {disclaimer}
      {error}
      {signInButton}
      {/* {signInB2bAccount} */}
    </Node>
  );
};

const SocialAccount: React.FC<ISignInSocialAccount> = ({
  socialAccounts,
  items,
}) => {
  return (
    <Node {...socialAccounts}>
      {items &&
        items.map((item: ISignInSocialItem) => {
          return (
            <Node key={item.key} {...item.button}>
              {item.image}
              {item.text}
            </Node>
          );
        })}
    </Node>
  );
};
const B2BAccount: React.FC<ISignInB2BAccount> = ({socialAccounts, items}) => {
  return (
    <Node {...socialAccounts}>
      {items &&
        items.map((item: ISignInB2BItem) => {
          return (
            item && (
              <Node key={item.key} {...item.button}>
                {item.text}
              </Node>
            )
          );
        })}
    </Node>
  );
};

const SignInLoading: React.FC<ISignInLoading> = ({
  modal,
  modalBody,
  icon,
  message,
}) => {
  return (
    <Node {...modal}>
      <Node {...modalBody}>
        {icon}
        {message}
      </Node>
    </Node>
  );
};

const SignInView: React.FC<ISignInViewProps | any> = (props) => {
  const {
    signIn,
    viewState,
    loading,
    defaultAADConainer,
    aadConainer,
    signInSection,
    signUpSection,
    signInLocalAccount,
    signInSocialAccount,
    signUpLink,
    signInB2BAccount,
  } = props;

  return (
    <Module {...signIn}>
      {viewState.isShowLoading && <Node {...defaultAADConainer} />}
      {viewState.isShowLoading && <SignInLoading {...loading} />}
      <Node {...aadConainer}>
        <Node {...signInSection}>
          <h2 className="ms-sign-in__sign-in-heading">
            {props.resources.signInHeading}
          </h2>
          {LocalAccount(signInLocalAccount)}
          {SocialAccount(signInSocialAccount)}
          {B2BAccount(signInB2BAccount)}
        </Node>
        <Node {...signUpSection}>
          <h2 className="ms-sign-in__sign-up-heading">
            {props.resources.dontHaveAccHeading}
          </h2>
          <p>{props.resources.signUpDescription}</p>
          {signUpLink}
        </Node>
      </Node>
    </Module>
  );
};

export default SignInView;
